import React, { useEffect, useState } from "react";

const headers = () => {
  const t = localStorage.getItem("access_token") || localStorage.getItem("token") || "";
  return { "Content-Type": "application/json", Authorization: "Bearer " + t };
};

const PartnerAffiliateCard = () => {
  const [pct, setPct] = useState("");
  const [saved, setSaved] = useState(null);
  const [loaded, setLoaded] = useState(false);
  const [msg, setMsg] = useState("");
  const [busy, setBusy] = useState(false);

  const load = () =>
    fetch("/api/partner-admin/affiliate-config", { headers: headers() })
      .then((r) => r.json())
      .then((d) => {
        if (d.ok && d.data) {
          const v = d.data.commissionPct;
          const has = v !== null && v !== undefined;
          setSaved(has ? v : null);
          setPct(has ? String(v) : "");
        }
        setLoaded(true);
      })
      .catch(() => setLoaded(true));

  useEffect(() => { load(); }, []);

  const save = (value) => {
    setBusy(true);
    fetch("/api/partner-admin/affiliate-config", { method: "PUT", headers: headers(), body: JSON.stringify({ commissionPct: value }) })
      .then((r) => r.json())
      .then((d) => {
        setMsg(d.message || d.error || "Saved");
        setTimeout(() => setMsg(""), 4000);
        return load();
      })
      .catch(() => setMsg("Failed"))
      .finally(() => setBusy(false));
  };

  const onSave = () => {
    const n = Number(pct);
    if (pct.trim() === "" || isNaN(n) || n < 0 || n > 100) {
      setMsg("Enter a number between 0 and 100");
      setTimeout(() => setMsg(""), 4000);
      return;
    }
    save(n);
  };

  const input = { padding: "8px 12px", width: 110, borderRadius: 6, border: "1px solid var(--border)", background: "var(--bg-elevated)", color: "var(--text-main)", fontSize: 14 };
  const btn = { padding: "8px 16px", borderRadius: 6, border: "none", cursor: busy ? "default" : "pointer", fontWeight: 700, fontSize: 13, background: "var(--accent)", color: "#fff", marginRight: 8 };
  const btn2 = { padding: "8px 16px", borderRadius: 6, border: "1px solid var(--border)", cursor: busy ? "default" : "pointer", fontWeight: 700, fontSize: 13, background: "transparent", color: "var(--text-main)" };

  return (
    <div style={{ marginTop: 28, padding: 16, borderRadius: 8, border: "1px solid var(--border)", background: "var(--bg-surface)" }}>
      <h3 style={{ color: "var(--text-main)", marginTop: 0 }}>Affiliate commission</h3>
      <p style={{ color: "var(--text-muted)", fontSize: 14, lineHeight: 1.5 }}>
        Commission rate (in percent) paid to members who refer others to your community. Leave it empty to turn the affiliate program off for your community.
      </p>
      {msg && <div style={{ background: "var(--success)", color: "#fff", padding: "8px 16px", borderRadius: 6, marginBottom: 12, display: "inline-block" }}>{msg}</div>}
      {!loaded ? (
        <div style={{ color: "var(--text-muted)" }}>Loading...</div>
      ) : (
        <div>
          <div style={{ color: "var(--text-muted)", fontSize: 13, marginBottom: 8 }}>
            Current: {saved === null ? "off (no affiliate program)" : saved + "%"}
          </div>
          <input type="number" min="0" max="100" step="0.5" value={pct} onChange={(e) => setPct(e.target.value)} placeholder="e.g. 10" style={input} />
          <span style={{ color: "var(--text-muted)", margin: "0 12px 0 6px" }}>%</span>
          <button disabled={busy} onClick={onSave} style={btn}>Save</button>
          <button disabled={busy || saved === null} onClick={() => { if (window.confirm("Turn off the affiliate program for your community?")) save(null); }} style={btn2}>Turn off</button>
        </div>
      )}
    </div>
  );
};

export default PartnerAffiliateCard;
